module.exports = __webpack_public_path__ + "img/64_14.c2bbf7f5.png";